export const IS_PRODUCTION = process.env.ENV === 'production';

const PRODUCTION_EXPERIMENTATION_API_KEY = '8e8d7680decb3dc29aa3f1b1548ec042';
const QA_EXPERIMENTATION_API_KEY = 'dc02e640a11e9e6f97c4954e84f9b33f';

export const EXPERIMENTATION_API_KEY = IS_PRODUCTION
  ? PRODUCTION_EXPERIMENTATION_API_KEY
  : QA_EXPERIMENTATION_API_KEY;

export const EXPERIMENTS = {};

export const EXPERIMENT_SHOP_BY_INTEREST = 'shopByInterest';

export const EXPERIMENT_OVERVIEW_TO_SHOP_STAGES = 'overviewToShopStages';

export const EXPERIMENT_CONFIGS = {
  // Must mirror EXPERIMENTS.shopByInterest baked into
  // @tkww/reg-shared-ui-navigation (5.x): the nav looks the passed assignment
  // up by its own experiment id, and a mismatch leaves it waiting on its 5s
  // fallback timer before rendering. The 5.x experiment defines no variant2.
  [EXPERIMENT_SHOP_BY_INTEREST]: {
    qa: {
      featureFlag: 'shop-by-interest',
      experimentId: '7bb995b8-9b18-4413-8c54-145f1c5daa2f',
      variants: {
        control: {
          id: 'ab8565f1-dd93-4eda-bce1-60d8282bb175',
        },
        variant1: {
          id: '9158f47d-3e64-4c75-8dec-6836efd118bc',
        },
      },
    },
    production: {
      featureFlag: 'shop-by-interest',
      experimentId: 'c66ff30d-17cc-43b7-941c-1208170a50b8',
      variants: {
        control: {
          id: '46fce5ed-9a01-4b81-aeba-9bf099f2f507',
        },
        variant1: {
          id: '2ed88db9-8700-4c08-9d55-2486511b5537',
        },
      },
    },
  },
  // Owned and bucketed by fe-member-registry (PDA-1998); this app only reads
  // existing assignments (PDA-2092). Ids must match FEMR's config.
  [EXPERIMENT_OVERVIEW_TO_SHOP_STAGES]: {
    qa: {
      featureFlag: 'overview-to-shop-stages',
      experimentId: 'a29d2c3d-fb7e-471f-bd85-254aa56085a7',
      variants: {
        control: {
          id: '0dea80ea-d9a0-4d18-95c5-bbd9476cd264',
        },
        variant: {
          id: '4ddb340b-4fc2-44e7-a3ec-8190acdc9268',
        },
      },
    },
    production: {
      featureFlag: 'overview-to-shop-stages',
      experimentId: 'a3d9f042-b615-46ed-8064-9afd65bf55ea',
      variants: {
        control: {
          id: 'dcfec6f8-27ff-47e4-b698-9438f0aac686',
        },
        variant: {
          id: 'c39ad9b0-4802-4a51-89b7-4771fee28aba',
        },
      },
    },
  },
};
